<div class="row m-0 review-info credit-app-body w-100" #scrollDiv [ngClass]="{'buyNowHeight': isBuyNow  && !isIframe, 'buyNowIframeHeight': isIframe ,'legacyCAheight': config.Sitecore.isLegacyCreditApp}">
  <div class="col-12 scrollDiv px-0">
    <div class="row m-0">
      <section class="col-12 h-auto px-0 personal-info">
        <div class="an-accordian">
          <input type="checkbox" id="personal-info-header" checked tabindex="-1"/>
          <label #personal_info_label (keyup.enter)="personal_info_label.click()" id="personal_info_label" 
            class="an-accordian-header" for="personal-info-header" role="link" tabindex="0">
            <span class="title an-h-line-height">{{ siteCoreData?.PersonalInfo }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_personal_info"
              (click)="loadComponent($event, siteCoreData?.PersonalInfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">{{ siteCoreData?.NameLabel }}</div>
              <div class="value-col w-100">
                <ng-container
                  *ngIf="buyer?.personalInformation?.middleName; else second"
                >
                  {{
                    buyer?.personalInformation?.firstName +
                      " " +
                      buyer?.personalInformation?.middleName +
                      " " +
                      buyer?.personalInformation?.lastName
                  }}
                </ng-container>
                <ng-template #second>
                  <ng-container>
                    {{
                      buyer?.personalInformation?.firstName +
                        " " +
                        buyer?.personalInformation?.lastName
                    }}
                  </ng-container>
                </ng-template>
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.EmailLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.emailAddress }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.PhoneLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.phoneNumber }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.DOBLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.financialInformation.securityInformation.dob | date:'M/d/yyyy' }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.Ssn1label }}
              </div>
              <div class="value-col w-100">
                  ***-**-
                {{
                    buyer?.financialInformation?.securityInformation?.ssn | slice:-4
                }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="col-12 h-auto px-0 resident-info">
        <div class="an-accordian">
          <input type="checkbox" id="resident-info-header" checked tabindex="-1"/>
          <label #resident_info_label (keyup.enter)="resident_info_label.click()" id="resident_info_label" 
            class="an-accordian-header" for="resident-info-header" role="link" tabindex="0">
            <span class="title  an-h-line-height">{{ siteCoreData?.ResideceInfo }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_resident_info"
              (click)="loadComponent($event, siteCoreData?.ResideceInfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.ResidenceTypeLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getResidenceType(
                    buyer?.financialInformation?.residenceInformation
                      ?.residenceType
                  )
                }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.MonthlyRentMortgageLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  buyer?.financialInformation?.residenceInformation
                    ?.monthlyMortgageAmount | currency: "USD":"symbol":"1.0"
                }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.AddressLine1label }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.currentAddress?.addressLine1 }}
              </div>
            </div>
            <div class="row mx-0 info-row" *ngIf="buyer?.personalInformation?.currentAddress?.addressLine2">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.AddressLine2label }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.currentAddress?.addressLine2 }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.ZipCodeLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.currentAddress?.postalCode }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.CityLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.currentAddress?.city }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.StateLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.personalInformation?.currentAddress?.stateCode }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.ReviewTotolyearMonthTitle }}
              </div>
              <div class="value-col w-100">
                {{
                  buyer?.personalInformation?.currentAddress?.yearsAtAddress +
                    " Years, " +
                    buyer?.personalInformation?.currentAddress
                      ?.monthsAtAddress +
                    " Months"
                }}
              </div>
            </div>
            <div
              class="row mx-0 info-row"
              *ngIf="buyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.AddressLine1label }}
              </div>
              <div class="value-col w-100">
                {{
                  (buyer?.personalInformation?.previousAddress)[0]?.addressLine1
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="buyer?.personalInformation?.previousAddress?.length > 0 && (buyer?.personalInformation?.previousAddress)[0]?.addressLine2"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.AddressLine2label }}
              </div>
              <div class="value-col w-100">
                {{
                  (buyer?.personalInformation?.previousAddress)[0]?.addressLine2
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="buyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.ZipCodeLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  (buyer?.personalInformation?.previousAddress)[0]?.postalCode
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="buyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.CityLabel }}
              </div>
              <div class="value-col w-100">
                {{ (buyer?.personalInformation?.previousAddress)[0]?.city }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="buyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.StateLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  (buyer?.personalInformation?.previousAddress)[0]?.stateCode
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="buyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.ReviewTotolyearMonthTitle }}
              </div>
              <div class="value-col w-100">
                {{
                  (buyer?.personalInformation?.previousAddress)[0]
                    ?.yearsAtAddress +
                    " Years, " +
                    (buyer?.personalInformation?.previousAddress)[0]
                      ?.monthsAtAddress +
                    " Months"
                }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="col-12 h-auto px-0 employment-info">
        <div class="an-accordian">
          <input type="checkbox" id="employment-info-header" checked tabindex="-1"/>
          <label id="employment_info_label" class="an-accordian-header" for="employment-info-header"
            #employment_info_label (keyup.enter)="employment_info_label.click()" role="link" tabindex="0">
            <span class="title  an-h-line-height">{{ siteCoreData?.EmploymentInfo }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_employment_info"
              (click)="loadComponent($event, siteCoreData?.EmploymentInfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.EmploymentStatusLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getEmploymentStatus(buyer?.financialInformation?.currentEmployer?.employmentStatus)
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="
              getEmploymentStatus(buyer?.financialInformation?.currentEmployer
                  ?.employmentStatus) !== 'Retired'
              "
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.EmploymentTypeLabel }}
              </div>
              <div class="value-col w-100">
                {{ getEmploymentType(buyer?.financialInformation?.currentEmployer?.jobType) }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="
              getEmploymentStatus(buyer?.financialInformation?.currentEmployer
                  ?.employmentStatus) !== 'Retired'
              "
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.EmployerNameLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.financialInformation?.currentEmployer?.employerName }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="
              getEmploymentStatus(buyer?.financialInformation?.currentEmployer
                  ?.employmentStatus) !== 'Retired'
              "
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.JobTitleLabel }}
              </div>
              <div class="value-col w-100">
                {{ buyer?.financialInformation?.currentEmployer?.jobTitle }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="
              getEmploymentStatus(buyer?.financialInformation?.currentEmployer
                  ?.employmentStatus) !== 'Retired'
              "
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.EmployerPhoneNumberLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getPhoneNumer(
                    buyer?.financialInformation?.currentEmployer?.phoneNumber
                  )
                }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.ReviewTotolyearMonthTitle }}
              </div>
              <div class="value-col w-100">
                {{
                  buyer?.financialInformation?.currentEmployer
                    ?.yearsAtEmployer +
                    " Years, " +
                    buyer?.financialInformation?.currentEmployer
                      ?.monthsAtEmployer +
                    " Months"
                }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.GrossSalaryLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  buyer?.financialInformation?.currentEmployer?.salary
                    | currency: "USD":"symbol":"1.0"
                }}
              </div>
            </div>

            <!--<div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.EmploymentInfo?.IncomeFrequencyLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getIncomeFrequency(buyer?.financialInformation?.currentEmployer?.frequency)
                }}
              </div>
            </div>-->
            <ng-container
             *ngIf="getFlag(buyer?.financialInformation?.currentEmployer?.yearsAtEmployer)">
                <div
                class="row mx-0 info-row"

              >
                <div class="label-col w-100 an-p-line-height">
                  {{
                    SCData?.PreviousEmploymentInfo?.PreviousEmploymentStatusLabel
                  }}
                </div>
                <div class="value-col w-100">
                  {{
                    getEmploymentStatus(buyer?.financialInformation?.previousEmployer
                      ?.employmentStatus)
                  }}
                </div>
              </div>
              <div
                class="row mx-0 info-row"
                *ngIf="
                getEmploymentStatus(buyer?.financialInformation?.previousEmployer
                    ?.employmentStatus) !== 'Retired'
                "
              >
                <div class="label-col w-100 an-p-line-height">
                  {{
                    SCData?.PreviousEmploymentInfo?.PreviousEmploymentTypeLabel
                  }}
                </div>
                <div class="value-col w-100">
                  {{ getEmploymentType(buyer?.financialInformation?.previousEmployer?.jobType) }}
                </div>
              </div>
              <div
                class="row mx-0 info-row"
                *ngIf="getEmploymentStatus(buyer?.financialInformation?.previousEmployer ?.employmentStatus) !== 'Retired'"
              >
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.PreviousEmploymentInfo?.PreviousEmployerNameLabel }}
                </div>
                <div class="value-col w-100">
                  {{
                    buyer?.financialInformation?.previousEmployer?.employerName
                  }}
                </div>
              </div>
              <div
                class="row mx-0 info-row"
                *ngIf="getEmploymentStatus(buyer?.financialInformation?.previousEmployer?.employmentStatus) !== 'Retired'">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.PreviousEmploymentInfo?.PreviousJobTitleLabel }}
                </div>
                <div class="value-col w-100">
                  {{ buyer?.financialInformation?.previousEmployer?.jobTitle }}
                </div>
              </div>
              <div
                class="row mx-0 info-row"
                *ngIf="getEmploymentStatus(buyer?.financialInformation?.previousEmployer ?.employmentStatus) !== 'Retired'">
                <div class="label-col w-100 an-p-line-height">
                  {{
                    SCData?.PreviousEmploymentInfo
                      ?.PreviousEmployerPhoneNumberLabel
                  }}
                </div>
                <div class="value-col w-100">
                  {{
                    getPhoneNumer(
                      buyer?.financialInformation?.previousEmployer?.phoneNumber
                    )
                  }}
                </div>
              </div>
              <div
                class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.PreviousEmploymentInfo?.ReviewTotolyearMonthTitle }}
                </div>
                <div class="value-col w-100">
                  {{
                    buyer?.financialInformation?.previousEmployer
                      ?.yearsAtEmployer +
                      " Years, " +
                      buyer?.financialInformation?.previousEmployer
                        ?.monthsAtEmployer +
                      " Months"
                  }}
                </div>
              </div>
              <div class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.PreviousEmploymentInfo?.PreviousGrossSalaryLabel }}
                </div>
                <div class="value-col w-100">
                  {{
                    buyer?.financialInformation?.previousEmployer?.salary
                      | currency: "USD":"symbol":"1.0"
                  }}
                </div>
              </div>


              <!--<div class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{
                    SCData?.PreviousEmploymentInfo?.PreviousIncomeFrequencyLabel
                  }}
                </div>
                <div class="value-col w-100">
                  {{
                    getIncomeFrequency(buyer?.financialInformation?.previousEmployer?.frequency)
                  }}
                </div>
              </div>-->
            </ng-container>


          </div>
        </div>
      </section>

      <section class="col-12 h-auto px-0 additional-income">
        <div class="an-accordian">
          <input type="checkbox" id="additional-income-header" checked tabindex="-1"/>
          <label id="additional_income_label" class="an-accordian-header" for="additional-income-header"
            #additional_income_label (keyup.enter)="additional_income_label.click()" role="link" tabindex="0">
            <span class="title an-h-line-height">{{ siteCoreData?.AdditionalIncome }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_additional_income"
              (click)="loadComponent($event, siteCoreData?.AdditionalInfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.AdditionalIncomeLabel }}
              </div>
              <div class="value-col w-100" *ngIf="buyer?.financialInformation?.otherIncomeInformation?.amount">
                {{
                  buyer?.financialInformation?.otherIncomeInformation?.amount
                    | currency: "USD":"symbol":"1.0"
                }}
              </div>
              <div class="value-col w-100" *ngIf="!buyer?.financialInformation?.otherIncomeInformation?.amount">
                No
              </div>
            </div>
            <!--<div class="row mx-0 info-row" *ngIf="buyer?.financialInformation?.otherIncomeInformation?.amount">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.IncomeFrequencyLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getIncomeFrequency(buyer?.financialInformation?.otherIncomeInformation?.frequency)
                }}
              </div>
            </div>-->

            <div class="row mx-0 info-row" *ngIf="buyer?.financialInformation?.otherIncomeInformation?.amount">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.IncomeSourceLabel }}
              </div>
              <div class="value-col w-100">
                {{ isLegacyCreditApp ? buyer?.financialInformation?.otherIncomeInformation
                  ?.otherIncome : buyer?.financialInformation?.otherIncomeInformation
                    ?.otherIncomeType
                }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="col-12 h-auto px-0 additional-info">
        <div class="an-accordian">
          <input type="checkbox" id="additional-info-header" checked tabindex="-1"/>
          <label id="additional_info_label" class="an-accordian-header" for="additional-info-header"
            #additional_info_label (keyup.enter)="additional_info_label.click()" role="link" tabindex="0">
            <span class="title  an-h-line-height">{{ siteCoreData?.AdditionalInfo }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_additional_info"
              (click)="loadComponent($event, siteCoreData?.AdditionalInfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.CoBuyerLabel }}
              </div>
              <div class="value-col w-100" *ngIf="!coBuyerExist">
                {{ SCData?.AdditionalInfo?.CoBuyerNo }}
              </div>

              <div class="value-col w-100" *ngIf="coBuyerExist">
                {{ SCData?.AdditionalInfo?.CoBuyerYes }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="col-12 h-auto px-0 Co-Buyer-personal-info" *ngIf="coBuyerExist">
        <div class="an-accordian">
          <input type="checkbox" id="Co-Buyer-personal-info-header" checked tabindex="-1"/>
          <label
            id="Co_Buyer_personal_info_label"
            class="an-accordian-header an-h-line-height"
            for="Co-Buyer-personal-info-header"
            #Co_Buyer_personal_info_label (keyup.enter)="Co_Buyer_personal_info_label.click()" role="link" tabindex="0"
          >
            <span class="title">{{ siteCoreData?.Cobuyerpersonalinfo }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_co_buyer_personal_info"
              (click)="loadComponent($event, siteCoreData?.Cobuyerpersonalinfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>

          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">{{ siteCoreData?.NameLabel }}</div>
              <div class="value-col w-100">
                <ng-container
                  *ngIf="buyer?.personalInformation?.middleName; else second"
                >
                  {{
                    cobuyer?.personalInformation?.firstName +
                      " " +
                      cobuyer?.personalInformation?.middleName +
                      " " +
                      cobuyer?.personalInformation?.lastName
                  }}
                </ng-container>
                <ng-template #second>
                  <ng-container>
                    {{
                      cobuyer?.personalInformation?.firstName +
                        " " +
                        cobuyer?.personalInformation?.lastName
                    }}
                  </ng-container>
                </ng-template>
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.EmailLabel }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.emailAddress }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.PhoneLabel }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.phoneNumber }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.DOBLabel }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.financialInformation.securityInformation.dob | date:'M/d/yyyy' }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PersonalInformation?.Ssn1label }}
              </div>
              <div class="value-col w-100">
                  ***-**-
                {{
                  cobuyer?.financialInformation?.securityInformation?.ssn | slice:-4
                }}
              </div>
            </div>
          </div>

        </div>
      </section>

      <section class="col-12 h-auto px-0 Co-Buyer-residence-info" *ngIf="coBuyerExist">
        <div class="an-accordian">
          <input type="checkbox" id="Co-Buyer-residence-info-header" checked tabindex="-1"/>
          <label
            id="Co_Buyer_residence_info_label"
            class="an-accordian-header an-h-line-height"
            for="Co-Buyer-residence-info-header"
            #Co_Buyer_residence_info_label (keyup.enter)="Co_Buyer_residence_info_label.click()" role="link" tabindex="0"
          >
            <span class="title">{{ siteCoreData?.Cobuyerreisdenceinfo }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_co_buyer_recidence_info"
              (click)="loadComponent($event, siteCoreData?.Cobuyerreisdenceinfo)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.ResidenceTypeLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getResidenceType(
                    cobuyer?.financialInformation?.residenceInformation
                      ?.residenceType
                  )
                }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.MonthlyRentMortgageLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  cobuyer?.financialInformation?.residenceInformation
                    ?.monthlyMortgageAmount | currency: "USD":"symbol":"1.0"
                }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.AddressLine1label }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.currentAddress?.addressLine1 }}
              </div>
            </div>
            <div class="row mx-0 info-row" *ngIf="cobuyer?.personalInformation?.currentAddress?.addressLine2">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.AddressLine2label }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.currentAddress?.addressLine2 }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.ZipCodeLabel }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.currentAddress?.postalCode }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.CityLabel }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.currentAddress?.city }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.StateLabel }}
              </div>
              <div class="value-col w-100">
                {{ cobuyer?.personalInformation?.currentAddress?.stateCode }}
              </div>
            </div>

            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.ResidenceInfo?.ReviewTotolyearMonthTitle }}
              </div>
              <div class="value-col w-100">
                {{
                  cobuyer?.personalInformation?.currentAddress?.yearsAtAddress +
                    " Years, " +
                    cobuyer?.personalInformation?.currentAddress
                      ?.monthsAtAddress +
                    " Months"
                }}
              </div>
            </div>
            <div
              class="row mx-0 info-row"
              *ngIf="cobuyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.AddressLine1label }}
              </div>
              <div class="value-col w-100">
                {{
                  (cobuyer?.personalInformation?.previousAddress)[0]?.addressLine1
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="cobuyer?.personalInformation?.previousAddress?.length > 0 && (cobuyer?.personalInformation?.previousAddress)[0]?.addressLine2"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.AddressLine2label }}
              </div>
              <div class="value-col w-100">
                {{
                  (cobuyer?.personalInformation?.previousAddress)[0]?.addressLine2
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="cobuyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.ZipCodeLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  (cobuyer?.personalInformation?.previousAddress)[0]?.postalCode
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="cobuyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.CityLabel }}
              </div>
              <div class="value-col w-100">
                {{ (cobuyer?.personalInformation?.previousAddress)[0]?.city }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="cobuyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.StateLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  (cobuyer?.personalInformation?.previousAddress)[0]?.stateCode
                }}
              </div>
            </div>

            <div
              class="row mx-0 info-row"
              *ngIf="cobuyer?.personalInformation?.previousAddress?.length > 0"
            >
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.PreviousResidenceInfo?.ReviewTotolyearMonthTitle }}
              </div>
              <div class="value-col w-100">
                {{
                  (cobuyer?.personalInformation?.previousAddress)[0]
                    ?.yearsAtAddress +
                    " Years, " +
                    (cobuyer?.personalInformation?.previousAddress)[0]
                      ?.monthsAtAddress +
                    " Months"
                }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="col-12 h-auto px-0 co-buyer-employment-info" *ngIf="coBuyerExist">
        <div class="an-accordian">
          <input type="checkbox" id="co-buyer-employment-info-header" checked tabindex="-1"/>
          <label
            id="co_buyer_employment_info_label"
            class="an-accordian-header an-h-line-height"
            for="co-buyer-employment-info-header"
            #co_buyer_employment_info_label (keyup.enter)="co_buyer_employment_info_label.click()" role="link" tabindex="0"
          >
            <span class="title">{{ siteCoreData?.Cobuyeremployment }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_co_buyer_employment_info"
              (click)="loadComponent($event, siteCoreData?.Cobuyeremployment)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
              <div class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.EmploymentStatusLabel }}
                </div>
                <div class="value-col w-100">
                  {{
                    getEmploymentStatus(cobuyer?.financialInformation?.currentEmployer?.employmentStatus)
                  }}
                </div>
              </div>

              <div
                class="row mx-0 info-row"
                *ngIf="
                getEmploymentStatus(cobuyer?.financialInformation?.currentEmployer
                    ?.employmentStatus) !== 'Retired'
                "
              >
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.EmploymentTypeLabel }}
                </div>
                <div class="value-col w-100">
                  {{ getEmploymentType(cobuyer?.financialInformation?.currentEmployer?.jobType) }}
                </div>
              </div>

              <div
                class="row mx-0 info-row"
                *ngIf="
                getEmploymentStatus(cobuyer?.financialInformation?.currentEmployer
                    ?.employmentStatus) !== 'Retired'
                "
              >
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.EmployerNameLabel }}
                </div>
                <div class="value-col w-100">
                  {{ cobuyer?.financialInformation?.currentEmployer?.employerName }}
                </div>
              </div>

              <div
                class="row mx-0 info-row"
                *ngIf="
                getEmploymentStatus(cobuyer?.financialInformation?.currentEmployer
                    ?.employmentStatus) !== 'Retired'
                "
              >
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.JobTitleLabel }}
                </div>
                <div class="value-col w-100">
                  {{ cobuyer?.financialInformation?.currentEmployer?.jobTitle }}
                </div>
              </div>

              <div
                class="row mx-0 info-row"
                *ngIf="
                getEmploymentStatus(cobuyer?.financialInformation?.currentEmployer
                    ?.employmentStatus) !== 'Retired'
                "
              >
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.EmployerPhoneNumberLabel }}
                </div>
                <div class="value-col w-100">
                  {{
                    getPhoneNumer(
                      cobuyer?.financialInformation?.currentEmployer?.phoneNumber
                    )
                  }}
                </div>
              </div>

              <div class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.ReviewTotolyearMonthTitle }}
                </div>
                <div class="value-col w-100">
                  {{
                    cobuyer?.financialInformation?.currentEmployer
                      ?.yearsAtEmployer +
                      " Years, " +
                      cobuyer?.financialInformation?.currentEmployer
                        ?.monthsAtEmployer +
                      " Months"
                  }}
                </div>
              </div>

              <div class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.GrossSalaryLabel }}
                </div>
                <div class="value-col w-100">
                  {{
                    cobuyer?.financialInformation?.currentEmployer?.salary
                      | currency: "USD":"symbol":"1.0"
                  }}
                </div>
              </div>

              <!--<div class="row mx-0 info-row">
                <div class="label-col w-100 an-p-line-height">
                  {{ SCData?.EmploymentInfo?.IncomeFrequencyLabel }}
                </div>
                <div class="value-col w-100">
                  {{
                    getIncomeFrequency(cobuyer?.financialInformation?.currentEmployer?.frequency)
                  }}
                </div>
              </div>-->
              <ng-container
               *ngIf="getFlag(cobuyer?.financialInformation?.currentEmployer?.yearsAtEmployer)">
                  <div
                  class="row mx-0 info-row"

                >
                  <div class="label-col w-100 an-p-line-height">
                    {{
                      SCData?.PreviousEmploymentInfo?.PreviousEmploymentStatusLabel
                    }}
                  </div>
                  <div class="value-col w-100">
                    {{
                      getEmploymentStatus(cobuyer?.financialInformation?.previousEmployer
                        ?.employmentStatus)
                    }}
                  </div>
                </div>
                <div
                  class="row mx-0 info-row"
                  *ngIf="
                  getEmploymentStatus(cobuyer?.financialInformation?.previousEmployer
                      ?.employmentStatus) !== 'Retired'
                  "
                >
                  <div class="label-col w-100 an-p-line-height">
                    {{
                      SCData?.PreviousEmploymentInfo?.PreviousEmploymentTypeLabel
                    }}
                  </div>
                  <div class="value-col w-100">
                    {{ getEmploymentType(cobuyer?.financialInformation?.previousEmployer?.jobType) }}
                  </div>
                </div>
                <div
                  class="row mx-0 info-row"
                  *ngIf=" getEmploymentStatus(cobuyer?.financialInformation?.previousEmployer ?.employmentStatus) !== 'Retired'"
                >
                  <div class="label-col w-100 an-p-line-height">
                    {{ SCData?.PreviousEmploymentInfo?.PreviousEmployerNameLabel }}
                  </div>
                  <div class="value-col w-100">
                    {{
                      cobuyer?.financialInformation?.previousEmployer?.employerName
                    }}
                  </div>
                </div>
                <div
                  class="row mx-0 info-row"
                  *ngIf="getEmploymentStatus(cobuyer?.financialInformation?.previousEmployer?.employmentStatus) !== 'Retired'">
                  <div class="label-col w-100 an-p-line-height">
                    {{ SCData?.PreviousEmploymentInfo?.PreviousJobTitleLabel }}
                  </div>
                  <div class="value-col w-100">
                    {{ cobuyer?.financialInformation?.previousEmployer?.jobTitle }}
                  </div>
                </div>
                <div
                  class="row mx-0 info-row"
                  *ngIf="getEmploymentStatus(cobuyer?.financialInformation?.previousEmployer ?.employmentStatus) !== 'Retired'">
                  <div class="label-col w-100 an-p-line-height">
                    {{
                      SCData?.PreviousEmploymentInfo
                        ?.PreviousEmployerPhoneNumberLabel
                    }}
                  </div>
                  <div class="value-col w-100">
                    {{
                      getPhoneNumer(
                        cobuyer?.financialInformation?.previousEmployer?.phoneNumber
                      )
                    }}
                  </div>
                </div>
                <div
                  class="row mx-0 info-row">
                  <div class="label-col w-100 an-p-line-height">
                    {{ SCData?.PreviousEmploymentInfo?.ReviewTotolyearMonthTitle }}
                  </div>
                  <div class="value-col w-100">
                    {{
                      cobuyer?.financialInformation?.previousEmployer
                        ?.yearsAtEmployer +
                        " Years, " +
                        cobuyer?.financialInformation?.previousEmployer
                          ?.monthsAtEmployer +
                        " Months"
                    }}
                  </div>
                </div>
                <div
                  class="row mx-0 info-row"
                >
                  <div class="label-col w-100 an-p-line-height">
                    {{ SCData?.PreviousEmploymentInfo?.PreviousGrossSalaryLabel }}
                  </div>
                  <div class="value-col w-100">
                    {{
                      cobuyer?.financialInformation?.previousEmployer?.salary
                        | currency: "USD":"symbol":"1.0"
                    }}
                  </div>
                </div>
                <!--<div class="row mx-0 info-row">
                  <div class="label-col w-100 an-p-line-height">
                    {{
                      SCData?.PreviousEmploymentInfo?.PreviousIncomeFrequencyLabel
                    }}
                  </div>
                  <div class="value-col w-100">
                    {{
                      getIncomeFrequency(cobuyer?.financialInformation?.previousEmployer?.frequency)
                    }}
                  </div>
                </div>-->
              </ng-container>


            </div>
        </div>
      </section>

      <section class="col-12 h-auto px-0 co-buyer-additional-income" *ngIf="coBuyerExist">
        <div class="an-accordian">
          <input
            type="checkbox"
            id="co-buyer-additional-income-header"
            checked
            tabindex="-1"
          />
          <label
            id="co_buyer_additional_income_label"
            class="an-accordian-header an-h-line-height"
            for="co-buyer-additional-income-header"
            #co_buyer_additional_income_label (keyup.enter)="co_buyer_additional_income_label.click()" role="link" tabindex="0"
          >
            <span class="title">{{ siteCoreData?.Cobuyeradditionalincome }}</span>
            <span
              class="edit" *ngIf="!isBuyNow && !isLegacyCreditApp"
              id="edit_co_buyer_additional_income"
              (click)="loadComponent($event, siteCoreData?.Cobuyeradditionalincome)"
              >{{ siteCoreData?.EditCTA }}</span
            >
          </label>
          <div class="an-accordian-content">
            <div class="row mx-0 info-row">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.AdditionalIncomeLabel }}
              </div>
              <div class="value-col w-100" *ngIf="cobuyer?.financialInformation?.otherIncomeInformation?.amount">
                {{
                  cobuyer?.financialInformation?.otherIncomeInformation?.amount
                    | currency: "USD":"symbol":"1.0"
                }}
              </div>
              <div class="value-col w-100" *ngIf="!cobuyer?.financialInformation?.otherIncomeInformation?.amount">
                No
              </div>
            </div>
            <!--<div class="row mx-0 info-row" *ngIf="cobuyer?.financialInformation?.otherIncomeInformation?.amount">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.IncomeFrequencyLabel }}
              </div>
              <div class="value-col w-100">
                {{
                  getIncomeFrequency(cobuyer?.financialInformation?.otherIncomeInformation?.frequency)
                }}
              </div>
            </div>-->

            <div class="row mx-0 info-row" *ngIf="cobuyer?.financialInformation?.otherIncomeInformation?.amount">
              <div class="label-col w-100 an-p-line-height">
                {{ SCData?.AdditionalInfo?.IncomeSourceLabel }}
              </div>
              <div class="value-col w-100">
                {{  isLegacyCreditApp ? cobuyer?.financialInformation?.otherIncomeInformation
                  ?.otherIncome : cobuyer?.financialInformation?.otherIncomeInformation
                    ?.otherIncomeType
                }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="col-12 h-auto concent-section">
        <div class="title an-h-line-height">{{ SCData?.ReviewInformation?.ConsentTitle }}</div>
        <div class="disclamier  an-p-line-height" *ngIf="!coBuyerExist">
          {{ SCData?.ReviewInformation?.Disclaimer }}
        </div>
        <div class="disclamier" *ngIf="coBuyerExist">
            {{ SCData?.ReviewInformation?.CoBuyerDisclaimer }}
          </div>
        <div class="concent-form">
          <form novalidate *ngIf="concentForm" [formGroup]="concentForm" class="d-flex row m-0">
            <div class="buyer-col pl-0 col-12 col-sm-6">
              <label class="an-p-line-height" for="buyer">{{ SCData?.ReviewInformation?.BuyerInitial }}</label>
              <input
                id="buyer"
                class="form-control w-100"
                type="text"
                formControlName="Buyer"
                maxlength="51"
                minlength="2"
                [ngClass]="{ error: (concentForm.get('Buyer').touched || concentForm.get('Buyer').dirty) && !concentForm.get('Buyer').valid}"
              />
              <span
                tabindex="0"
                class="form-error-x dt-icon dt-icon-input-clear mt-4"
                *ngIf="
                  (concentForm.get('Buyer').touched ||
                    concentForm.get('Buyer').dirty) &&
                  !!concentForm.get('Buyer').errors
                "
                (click)="concentForm.get('Buyer').reset()"
                (keyup)="
                  $event?.keyCode === 13
                    ? concentForm.get('Buyer').reset()
                    : null
                "
              >

              </span>
              <div class="invalid-feedback d-block">
                <span
                  class="form-validator_error"
                  *ngIf="
                    (concentForm.get('Buyer').touched ||
                      concentForm.get('Buyer').dirty) &&
                    !concentForm.get('Buyer').valid
                  "
                >
                  <ng-container *ngIf="!!concentForm.get('Buyer').errors">
                    {{ SCData?.ReviewInformation?.BuyerInitialRequired }}
                  </ng-container>
                </span>
              </div>
            </div>
            <div class="cobuyer-col pr-0 col-12 col-sm-6" *ngIf="coBuyerExist">
              <label class="an-p-line-height" for="cobuyer">{{ SCData?.ReviewInformation?.CobuyerIntial }}</label>
              <input
                id="cobuyer"
                class="form-control w-100"
                type="text"
                formControlName="Cobuyer"
                maxlength="51"
                minlength="2"
                [ngClass]="{
                  error:
                    (concentForm.get('Cobuyer').touched ||
                      concentForm.get('Cobuyer').dirty) &&
                    !concentForm.get('Cobuyer').valid
                }"
              />
              <span
                tabindex="0"
                class="form-error-x dt-icon dt-icon-input-clear mt-4"
                *ngIf="
                  (concentForm.get('Cobuyer').touched ||
                    concentForm.get('Cobuyer').dirty) &&
                  !!concentForm.get('Cobuyer').errors
                "
                (click)="concentForm.get('Cobuyer').reset()"
                (keyup)="
                  $event?.keyCode === 13
                    ? concentForm.get('Cobuyer').reset()
                    : null
                "
              >

              </span>
              <div class="invalid-feedback d-block">
                <span
                  class="form-validator_error"
                  *ngIf="
                    (concentForm.get('Cobuyer').touched ||
                      concentForm.get('Cobuyer').dirty) &&
                    !concentForm.get('Cobuyer').valid
                  "
                >
                  <ng-container *ngIf="!!concentForm.get('Cobuyer').errors">
                    {{ SCData?.ReviewInformation?.CoBuyerInitialRequired }}
                  </ng-container>
                </span>
              </div>
            </div>
          </form>
        </div>
      </section>


    </div>
  </div>

  <div class="col-12 scollDownBtn" *ngIf="showScrollDownCTA">
    <div class="text-center btnContainer text-center" (click)="scrollToBottom()">
      <div class="title text-gray"> {{siteCoreData?.ScrollDown}} </div>
      <div class="dt-icon dt-icon-back-button"></div>
    </div>

  </div>
 
<a id="bottom"></a>
<div class="credit-app-cta-section">
  <div class="row m-0  w-100 cta-section">
    <div class="col-12 d-flex m-0 p-0 cta-alignment">
      <button type="button" id="back_cta" class="secondary-cta mr-auto" [disabled]="isSaving" (click)="goBack()">
        {{ SCData?.ReviewInformation?.BackCta }}
      </button>
      <button
        (click)="goNext()"
        type="button"
        id="next_cta"
        class="primary-cta ml-auto"
        [disabled]="!concentForm?.valid || isSaving"
      >
        {{ SCData?.ReviewInformation?.NextCta }}
      </button>
    </div>
  </div>
</div>
